import { BuyerSplitSettingState } from '../views/RulesEngine/Pages/Buyer/BuyerSplitSettings/BuyerSplitSettingTypes';
import { BuyerActivitySummaryState } from '../views/RulesEngine/Pages/Buyer/BuyerActivitySummary/BuyerActivitySummaryTypes';
import { CurrentLendersState } from '../views/RulesEngine/Pages/Lender/CurrentLenders/CurrentLenderTypes';
import { BuyerGroupState } from '../views/RulesEngine/Pages/Buyer/BuyerGroup/BuyerGroupTypes';
import { AuthState } from '../actions/AuthTypes';
import { DisclosureScreenState } from '../views/RulesEngine/Pages/Buyer/Disclosure/DisclosureTypes';
import { VetsuRedirectState } from '../views/RulesEngine/Pages/Vetsu/VetsuRedirect/VetsuRedirectTypes';
import { PersonalLoanRedirectScreenState } from '../views/RulesEngine/Pages/Loans/PersonalLoanRedirect/Types';
import { ThankYouPageState } from '../views/RulesEngine/Pages/Buyer/ThankYouPage/ThankYouPageTypes';

export const API_HOST:string = process.env.REACT_APP_API_HOST || '';

export interface StoreStruct {
  form: object;
  auth: AuthState;
  buyerSplitSettings: BuyerSplitSettingState;
  buyerActivity: BuyerActivitySummaryState;
  BuyerGroup: BuyerGroupState;
  currentLenders: CurrentLendersState;
  disclosure: DisclosureScreenState;
  vetsURedirect: VetsuRedirectState;
  personalLoanRedirect: PersonalLoanRedirectScreenState;
  thankYouPage: ThankYouPageState;
}
